export const CREATED_STATUS_OPTIONS = [
  { label: 'Em elaboração', value: 'Em elaboração' },
  { label: 'Enviado', value: 'Enviado' },
  { label: 'Recebido', value: 'Recebido' },
]

export const RECEIVED_STATUS_OPTIONS = [
  { label: 'Resposta pendente', value: 'Resposta pendente' },
  { label: 'Finalizado', value: 'Finalizado' },
]

export const CREATED_STATUS_COLOR_MAP = {
  'Em elaboração': '#f0ad4e',
  'Enviado': '#5bc0de',
  'Recebido': '#5cb85c',
}

export const RECEIVED_STATUS_COLOR_MAP = {
  'Resposta pendente': '#f0ad4e',
  'Finalizado': '#5cb85c',
}

/** Aliases de e-mail das gerências + TI (testes) */
export const GERENCIA_EMAIL_OPTIONS = [
  { value: 'gerencia.juridico@ecossis.com.br', label: 'Jurídico' },
  { value: 'gerencia.financeira@ecossis.com.br', label: 'Financeiro' },
  { value: 'gerencia.tecnico@ecossis.com.br', label: 'Técnico' },
  { value: 'gerencia.rh@ecossis.com.br', label: 'RH' },
  { value: 'gerencia.comercial@ecossis.com.br', label: 'Comercial' },
  { value: 'ti@ecossis.com.br', label: 'TI' },
]

/** Dep. técnico (projetos): mesmas opções de encaminhamento */
export const PROJECT_FORWARD_EMAIL_OPTIONS = GERENCIA_EMAIL_OPTIONS

export const LEGAL_SUBJECT_OPTIONS = [
  { label: 'Análise de Contrato', value: 'Análise de Contrato' },
  { label: 'Elaboração de Contrato', value: 'Elaboração de Contrato' },
  { label: 'Parecer Jurídico', value: 'Parecer Jurídico' },
  { label: 'Consultoria Jurídica', value: 'Consultoria Jurídica' },
  { label: 'Dúvida', value: 'Dúvida' },
  { label: 'Outros', value: 'Outros' },
]

export const LEGAL_PRIORITY_OPTIONS = [
  { label: 'Urgente', value: 'Urgente' },
  { label: 'Importante', value: 'Importante' },
  { label: 'Sugestão', value: 'Sugestão' },
]

export const buildLegalDemandDefaults = ({
  solicitante = '',
  assunto = '',
  numeroOficio = '',
  dataOficio = null,
  teor = '',
}) => {
  const tipo = LEGAL_SUBJECT_OPTIONS.find(
    o => o.value.toLowerCase() === String(assunto).trim().toLowerCase()
  ) || LEGAL_SUBJECT_OPTIONS.find(o => o.value === 'Outros')

  return {
    solicitante,
    tipo_assunto: tipo.value,
    prioridade: 'Sugestão',
    prazo_atendimento: dataOficio || null,
    fato_gerador: numeroOficio ? `Ofício ${numeroOficio}` : '',
    teor,
  }
}

export const getNextOficioNumber = (letters, year = new Date().getFullYear()) => {
  const prefix = `${year}/`
  const nums = (letters || [])
    .map(l => l.numero_oficio)
    .filter(n => n && String(n).startsWith(prefix))
    .map(n => parseInt(String(n).split('/')[1], 10))
    .filter(n => !Number.isNaN(n))
  const next = (nums.length ? Math.max(...nums) : 0) + 1
  return `${year}/${String(next).padStart(3, '0')}`
}

export const getRowId = (row, isCreated) => (
  isCreated
    ? (row.id || row.oficios_criados_id)
    : (row.id || row.oficios_recebidos_id)
)

/** react-select dentro de Modal: menu no body evita sobreposição com outros campos */
export const MODAL_SELECT_PROPS = {
  className: 'basic-single',
  classNamePrefix: 'select',
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  menuPosition: 'fixed',
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    option: (base) => ({
      ...base,
      padding: '8px 12px',
      lineHeight: 1.4,
      minHeight: 'auto',
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 220,
      paddingTop: 4,
      paddingBottom: 4,
    }),
  },
}

export const MODAL_MULTI_SELECT_PROPS = {
  ...MODAL_SELECT_PROPS,
  className: 'basic-multi-select',
}

export const EDITOR_TOOLBAR = {
  options: ['inline', 'list'],
  inline: { options: ['bold', 'italic', 'underline'] },
  list: { options: ['unordered', 'ordered'] },
}

export const EDITOR_WRAPPER_STYLE = {
  border: '1px solid #ced4da',
  borderRadius: 4,
  minHeight: 150,
  padding: 2,
  position: 'relative',
}

export const EDITOR_INNER_STYLE = {
  minHeight: 120,
  paddingLeft: 8,
  paddingRight: 8,
  fontSize: 14,
}
